export default __webpack_public_path__ + "media/images/brands/expmessenger/logos/email_logo-3498ab036a49f09e563219a566982b3c.png";